import { QueryTarget } from "@/shared/domain/query";
import { VIEW_TARGETS, type ViewTarget } from "@/shared/domain/views";

import { COLLECTION_FILTER_FIELDS } from "./collections";
import { DATASET_FILTER_FIELDS } from "./datasets";
import { DEVICE_FILTER_FIELDS } from "./devices";
import { EVENT_FILTER_FIELDS } from "./events";
import { FILE_FILTER_FIELDS } from "./files";
import { SESSION_FILTER_FIELDS } from "./sessions";
import type { StaticFilterField } from "./StaticFilterField";

export {
  hydrateFilterDefinitions,
  type FilterRuntime,
  type StaticFilterField,
} from "./StaticFilterField";
export { DATASET_FILTER_FIELDS } from "./datasets";
export {
  FILE_FILTER_FIELDS,
  FILE_FILTER_FIELDS_BY_STATUS,
  INGESTION_LABEL_OPTIONS,
  INGESTION_STATUS_LABELS,
} from "./files";
export { EVENT_FILTER_FIELDS } from "./events";
export {
  SESSION_CORE_FILTER_FIELDS,
  SESSION_FILTER_FIELDS,
  sessionDatasetIdFilter,
  sessionDeviceIdFilter,
} from "./sessions";
export { DEVICE_FILTER_FIELDS } from "./devices";
export { COLLECTION_FILTER_FIELDS } from "./collections";

const CATALOG: Record<ViewTarget, readonly StaticFilterField[]> = {
  [QueryTarget.Datasets]: DATASET_FILTER_FIELDS,
  [QueryTarget.Files]: FILE_FILTER_FIELDS,
  [QueryTarget.Events]: EVENT_FILTER_FIELDS,
  [QueryTarget.Sessions]: SESSION_FILTER_FIELDS,
  [QueryTarget.Devices]: DEVICE_FILTER_FIELDS,
  [QueryTarget.Collections]: COLLECTION_FILTER_FIELDS,
};

/**
 * Every statically known filter row for a table, in picker order; none for a
 * target no View can be saved from. Custom fields and metrics are per-org and
 * are not here; a list appends them from its own hooks, and the View tools
 * fetch them at execution time.
 */
export function staticFilterFieldsFor(
  target: QueryTarget,
): readonly StaticFilterField[] {
  const viewTarget = VIEW_TARGETS.find((candidate) => candidate === target);
  return viewTarget === undefined ? [] : CATALOG[viewTarget];
}
